import { IABAAppointmentSubType } from 'model/abaAppointmentSubtype';
import { IDTAppointmentSubType } from 'model/DTAppointmentSubType';
import { IMEDAppointmentSubType } from 'model/MEDAppointmentSubtype';

export const formatABASubTypeToInput = (
  data: IABAAppointmentSubType,
  initialValues: IABAAppointmentSubType
) => {
  return {
    id: Number(initialValues?.id),
    title: data.title,
    placeOfServiceId: Number(data.placeOfService?.id),
    appointmentType: {
      id: Number(data.superType?.id)
    }
  };
};

export const formatDTSubTypeToInput = (
  data: IDTAppointmentSubType,
  initialValues: IDTAppointmentSubType
) => {
  return {
    id: Number(initialValues?.DTSettingId),
    athenaId: Number(data.athenaId),
    duration: data.duration,
    appointmentType: {
      id: Number(initialValues?.id),
      title: data.title,
      isActive: data.isActive,
      parent: { id: Number(data.superType.id) },
      eventType: { id: 2 },
      salesForceTherapyMappings: {
        id: data.salesForceMapping?.id
      }
    }
  };
};

export const formatCounselingSubTypeToInput = (
  data: IDTAppointmentSubType,
  initialValues: IDTAppointmentSubType
) => {
  return {
    id: Number(initialValues?.CounselingSettingId),
    athenaId: Number(data.athenaId),
    duration: data.duration,
    appointmentType: {
      id: Number(initialValues?.id),
      title: data.title,
      isActive: data.isActive,
      parent: { id: Number(data.superType.id) },
      // NOTE: eventType is intentionally omitted here — the Counseling
      // EventType id is environment-dependent (created by migration), so the
      // backend resolves and assigns it by name on save
      // (AppointmentTypeService.putAppointmentSubType). This guarantees new and
      // edited Counseling subtypes always persist with the correct eventTypeId.
      salesForceTherapyMappings: {
        id: data.salesForceMapping?.id
      }
    }
  };
};

export const formatMEDSubTypeToInput = (
  data: IMEDAppointmentSubType,
  initialValues: IMEDAppointmentSubType
) => {
  return {
    id: Number(initialValues?.MEDSettingId),
    athenaId: Number(data.athenaId),
    duration: data.duration,
    appointmentType: {
      id: Number(initialValues?.id),
      title: data.title,
      isActive: data.isActive,
      parent: { id: Number(data.superType.id) },
      eventType: { id: 4 }
    }
  };
};
